module.exports = __webpack_public_path__ + "img/fire-smoke-glow.3aaf04c9.png";